import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const title = css`
  text-align: center;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    font-size: 1.5rem;
    line-height: 2rem;
  }
`;
